import { FormControlLabel, FormGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles({
  formGroupRoot: {
    flexWrap: 'nowrap',
  },
  switchRoot: {
    width: 60,
  },
  checked: {
    transform: 'translateX(20px) !important',
  },
  inBetween: {
    transform: 'translateX(11px)',
  },
});

export default function InBetweenSwitch({ label, value, onChange, appendix, ...props }) {
  const classes = useStyles();
  return (
    <FormGroup
      row
      className={props.className}
      classes={{
        root: classes.formGroupRoot,
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={!!value}
            onChange={onChange}
            color="primary"
            classes={{
              root: classes.switchRoot,
              thumb: '!w-[18px] !h-[18px]',
              switchBase: `!p-[10px] ${value == null && classes.inBetween}`,
              checked: classes.checked,
            }}
          />
        }
        label={label}
        className={'text-overflow-ellipsis !mr-0'}
      />
      {appendix && appendix}
    </FormGroup>
  );
}
